// extracted by mini-css-extract-plugin
export default {"shareButton":"share_shareButton__NefAH","icon":"share_icon__0Cahg","check":"share_check__9Wsyq"};